module.exports = __webpack_public_path__ + "img/KJJZHMD_IOS.15060d98.png";